// extracted by mini-css-extract-plugin
export default {"moduleWrapper":"HorizontalVideo_moduleWrapper__h+5t3"};